import { Avatar, Button, Flex } from 'antd'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'

export const AgentButton = ({
  agent,
  onClick,
}: {
  agent: OrganizationMemberFromContext
  onClick: () => void
}) => {
  return (
    <Flex gap={8} flex={1} align="center">
      <Avatar
        size={54}
        src={agent?.appSession.pictureUrl}
        style={{ flexShrink: 0, border: '1px solid grey' }}
      />
      <Button type="primary" onClick={onClick}>
        Ask {agent?.appSession.name}
      </Button>
    </Flex>
  )
}
